import { SubscriptionCard } from "./SubscriptionCard";
import { DeviceList } from "./DeviceList";
import type { SubscriptionViewModel } from "../../subscriptionView";

export function HomeScreen({ me, labels }: { me: SubscriptionViewModel; labels: Record<string, string> }) {
  return (
    <div>
      <SubscriptionCard me={me} labels={labels} />
      <h2 className="font-bold mt-6 mb-2">{labels.devicesTab}</h2>
      <DeviceList labels={labels} />
    </div>
  );
}
